import React from "react";

import { Screen } from "@/components";

export const ErrorPage = (props) => {
  return (
    <Screen>
      <div>error</div>

      <div>{JSON.stringify(props, null, 2)}</div>
      <div>query error</div>
      <div>{JSON.stringify(props, null, 2)}</div>
      <div>{JSON.stringify(props, null, 2)}</div>
    </Screen>
  );
};
